import { grey } from '@material-ui/core/colors';
export const primary = {
  light: '#D1E288',
  main: '#bbd05e',
  dark: '#92A831',
  contrastText: '#fff'
};
export const secondary = {
  light: '#B9DCD2',
  main: '#BAC5B9',
  dark: '#708866',
  contrastText: '#fff'
};
export const success = {
  light: '#92D982',
  main: '#89CD7A',
  dark: '#344D2E',
  contrastText: '#fff'
};
export const error = {
  light: '#DFC2C3',
  main: '#DC7C86',
  dark: '#C00D1E',
  contrastText: '#fff'
};
export const warning = {
  light: '#FAE5A0',
  main: '#ECD898',
  dark: '#6E6446',
  contrastText: '#fff'
};
export const info = {
  light: '#B1C7E3',
  main: '#A7BCD6',
  dark: '#444C57',
  contrastText: '#fff'
};
export const text = {
  primary: '#333',
  secondary: '#555',
  disabled: '#999',
  hint: '#CCC'
};
export const textExtra = {
  heading: '#555',
  contrast: '#777'
};
export const action = {
  disabledBackground: '#CCC'
};
export const commonColors = {
  white: '#FFF',
  black: '#000'
};
export const background = {
  paper: commonColors.white,
  default: grey[50],
  chromeWhite: '#E1EFCE',
  pigeonPost: '#A7BCD6',
  chatelle: '#B3B0C4',
  pinkFlare: '#DFC2C3',
  wafer: '#E4D5D3',
  newOrleans: '#F0BF9B',
  softAmber: '#D7C4B7',
  snowFlurry: '#DCFFBD',
  viking: '#6ED0DE',
  danube: '#6B93D7',
  bouquet: '#B36FAF',
  kobi: '#EEA7C2',
  porsche: '#EFAE6E',
  kournikova: '#FFDA78',
  sandal: '#B48F73',
  highland: '#708866',
  wedgewood: '#4C919C',
  kashmirBlue: '#4C6C9C',
  trendyPink: '#856C98',
  strikeMaster: '#98607C',
  santaFe: '#B57363',
  tussock: '#C7984F',
  husk: '#B89F58',
  sandDune: '#837165',
  chalky: '#ECD898',
  edgeWater: '#B9DCD2',
  greenSpring: '#B9C5B8',
  athensGray: '#EAEAF0'
};
export const oriGrey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#e5e5e5',
  300: '#cccccc',
  400: '#bbbbbb',
  500: '#888888',
  600: '#777777',
  700: '#555555',
  800: '#444444',
  900: '#333333',
  A100: '#f0f0f0',
  A200: '#dddddd',
  A400: '#999999',
  A700: '#666666',
  A900: '#2a2a2a'
};